import fdaBadge from "../../assets/img/badge-fda.png";
import fdaBadgeWebp from "../../assets/img/badge-fda.webp";
import naturalBadge from "../../assets/img/badge-natural.png";
import naturalBadgeWebp from "../../assets/img/badge-natural.webp";
import gmoFreeBadge from "../../assets/img/badge-gmo-free.png";
import gmoFreeBadgeWebp from "../../assets/img/badge-gmo-free.webp";
import madeInUsaBadge from "../../assets/img/badge-made-in-usa.png";
import madeInUsaBadgeWebp from "../../assets/img/badge-made-in-usa.webp";
import gmpBadge from "../../assets/img/badge-gmp.png";
import gmpBadgeWebp from "../../assets/img/badge-gmp.webp";

const Badges = () => (
    <section id="badges">
        <div className="container-fluid py-3">
            <div className="row align-items-center justify-content-center">
                <div className="col-xxl-8 col-xl-10">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-2 justify-content-center align-items-center text-center">
                            <picture>
                                <source srcSet={fdaBadgeWebp} type="image/webp" />
                                <img className="img-fluid gg-img-badge" src={fdaBadge} loading="lazy"/>
                            </picture>
                        </div>
                        <div className="col-2 justify-content-center align-items-center text-center">
                            <picture>
                                <source srcSet={naturalBadgeWebp} type="image/webp" />
                                <img className="img-fluid gg-img-badge" src={naturalBadge} loading="lazy"/>
                            </picture>

                        </div>
                        <div className="col-2 justify-content-center align-items-center text-center">
                            <picture>
                                <source srcSet={gmoFreeBadgeWebp} type="image/webp" />
                                <img className="img-fluid gg-img-badge" src={gmoFreeBadge} loading="lazy"/>
                            </picture>
                        </div>
                        <div className="col-2 justify-content-center align-items-center text-center">
                            <picture>
                                <source srcSet={madeInUsaBadgeWebp} type="image/webp" />
                                <img className="img-fluid gg-img-badge" src={madeInUsaBadge} loading="lazy"/>
                            </picture>
                            <div className="gg-very-very-small-text">This formula is proudly made in the United States of America from the finest foreign and domestic ingredients</div>
                        </div>
                        <div className="col-2 justify-content-center align-items-center text-center">
                            <picture>
                                <source srcSet={gmpBadgeWebp} type="image/webp" />
                                <img className="img-fluid gg-img-badge" src={gmpBadge} loading="lazy"/>
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Badges;